import { NgModule } from "@angular/core";
import { TaskFormImagesGalleryComponent } from "./form-images-gallery.component";
import { CommonModule } from "@angular/common";
import { ShimmerModule } from "src/app/common-components/shimmer/shimmer.module";
import { CommonComponentsModule } from "src/app/common-components";

@NgModule({
    imports: [
        CommonModule,
        ShimmerModule,
        CommonComponentsModule
    ],
    declarations: [TaskFormImagesGalleryComponent],
    exports: [TaskFormImagesGalleryComponent]
})
export class TaskFormImagesGalleryModule { }